export const LOWER_CASE_SERVICE_NAME = {
  FLEXIO_SHIFT: "flexio shift",
  FLEXIO_NOW: "flexio now",
  INTERNAL_DRIVER: "internal driver"
};
